import { render, staticRenderFns } from "./Footerbar.vue?vue&type=template&id=2d5344f2&scoped=true&"
var script = {}
import style0 from "./Footerbar.vue?vue&type=style&index=0&id=2d5344f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5344f2",
  null
  
)

export default component.exports